import { trackGA4Event } from '@gumtree/shared/src/util/ga4-shared';
import { SearchAd } from '@gumtree/shared/src/model/search-ads-model';
import { SellerAd } from '@gumtree/shared/src/model/seller-other-ads-model';
import { getClickListingDetails } from '@gumtree/shared/src/util/listing-details';
import { setRequestId } from '@gumtree/shell/src/request-id';

interface HandleClickParams {
    e: React.MouseEvent<HTMLAnchorElement>;
    type: 'listing' | 'profile-listing';
    ad: SearchAd | SellerAd;
    path: string;
}

export const handleListingClick = async ({
    e,
    type,
    ad,
    path,
}: HandleClickParams) => {
    e.preventDefault();

    const { listName, linkSection } = 
        type === 'profile-listing'
            ? { listName: 'Profile', linkSection: 'Company Jobs Profile Ads' }
            : { listName: 'Search Result', linkSection: 'Search Result Ads' };

    trackGA4Event<any>({
        event: 'click_listing',
        linkDomain: window.location.host,
        linkURL: path,
        linkText: undefined,
        linkType: 'card',
        linkSection,
        listName,
        clickListingDetails: getClickListingDetails(ad),
        pageNum: +(
            new URL(window.location.href).searchParams.get('page') ||
            (window as any).gumtreeDataLayer?.[0]?.searchParameters?.pageNumber ||
            1
        ),
        listingSource: ad.adSource?.toLowerCase() || 'gt'
    });

    setRequestId(path);
    window.open(path, '_blank', 'noopener');
};
